import React from 'react';
import styled from 'styled-components';

const Description = styled.div`
  p {
    color: #000000;
    font-family: 'OCRoboto';
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
  }
  a {
    color: #000000;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
    text-decoration-line: underline;
  }
`;

export default ({ text }) => <Description dangerouslySetInnerHTML={{ __html: text }} />;
